/// <reference types="googlemaps" />

let geocoder: google.maps.Geocoder;

const geocode = (request: google.maps.GeocoderRequest): Promise<google.maps.GeocoderResult[]> => {
	if (!geocoder) {
		geocoder = new google.maps.Geocoder();
	}

	return new Promise((resolve, reject) => {
		geocoder.geocode(request, (results: google.maps.GeocoderResult[], status: google.maps.GeocoderStatus) => {
			if (status === google.maps.GeocoderStatus.OK) {
				resolve(results);
			} else {
				reject(status);
			}
		});
	});
};

export default geocode;
